export const hasStrongTag = (inputString:string) => {
    const strongTagRegex = /<strong\b[^>]*>(.*?)<\/strong>/;
    return strongTagRegex.test(inputString);
  }